import { render, staticRenderFns } from "./box.vue?vue&type=template&id=a3524ec0&scoped=true"
import script from "./box.vue?vue&type=script&lang=js"
export * from "./box.vue?vue&type=script&lang=js"
import style0 from "./box.vue?vue&type=style&index=0&id=a3524ec0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3524ec0",
  null
  
)

export default component.exports